var _class, _descriptor, _DMenus;
function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;
  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }
  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);
  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }
  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }
  return desc;
}
function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.');
}
import Component from "@glimmer/component";
import { inject as service } from "@ember/service";
import DHeadlessMenu from "float-kit/components/d-headless-menu";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let DMenus = (_class = (_DMenus = class DMenus extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "menu", _descriptor, this);
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div id="d-menu-portals"></div>

    {{#each this.menu.registeredMenus key="id" as |menu|}}
      {{#if menu.detachedTrigger}}
        <DHeadlessMenu @menu={{menu}} />
      {{/if}}
    {{/each}}
  
*/
{
  "id": "rtCNRCrc",
  "block": "[[[1,\"\\n    \"],[10,0],[14,1,\"d-menu-portals\"],[12],[13],[1,\"\\n\\n\"],[42,[28,[31,1],[[28,[31,1],[[30,0,[\"menu\",\"registeredMenus\"]]],null]],null],\"id\",[[[41,[30,1,[\"detachedTrigger\"]],[[[1,\"        \"],[8,[32,0],null,[[\"@menu\"],[[30,1]]],null],[1,\"\\n\"]],[]],null]],[1]],null],[1,\"  \"]],[\"menu\"],false,[\"each\",\"-track-array\",\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/float-kit.d0433c99/node_modules/float-kit/components/d-menus.js",
  "scope": () => [DHeadlessMenu],
  "isStrictMode": true
}), _DMenus), _DMenus), _descriptor = _applyDecoratedDescriptor(_class.prototype, "menu", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DMenus as default };